var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#EDEEF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1524_3734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1524_3734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6882 14.625V33.375C28.6884 33.5605 28.6335 33.7419 28.5305 33.8962C28.4275 34.0505 28.281 34.1708 28.1096 34.2418C27.9382 34.3129 27.7496 34.3314 27.5676 34.2952C27.3857 34.259 27.2186 34.1695 27.0875 34.0383L17.7125 24.6633C17.6253 24.5762 17.5561 24.4728 17.509 24.359C17.4618 24.2452 17.4375 24.1232 17.4375 24C17.4375 23.8768 17.4618 23.7548 17.509 23.641C17.5561 23.5272 17.6253 23.4238 17.7125 23.3367L27.0875 13.9617C27.2186 13.8305 27.3857 13.7411 27.5676 13.7048C27.7496 13.6686 27.9382 13.6872 28.1096 13.7582C28.281 13.8292 28.4275 13.9495 28.5305 14.1038C28.6335 14.2581 28.6884 14.4395 28.6882 14.625Z",
    fill: "#343330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.2869c9fa52418153d0312a597bcbbeb9.svg";
export { ForwardRef as ReactComponent };